import React from 'react';
import { Redirect } from 'react-router-dom';
import { userVar } from '../../graphql/config';
import { LINK_GROUP } from '../../utils/links';

const LandingPage = () => {
  if (userVar()?.access_token) {
    let dashboard;

    switch (userVar().type.toLowerCase()) {
      case LINK_GROUP.COMPANY:
        dashboard = `/${LINK_GROUP.EMPLOYER}/dashboard`;
        break;

      case LINK_GROUP.AGENCY:
        dashboard = `/${LINK_GROUP.AGENCY}/dashboard`;
        break;

      default:
        dashboard = `/${LINK_GROUP.CANDIDATE}/dashboard`;
        break;
    }
    return (
      <Redirect
        to={{
          pathname: dashboard,
          state: { referrer: '/' },
        }}
      />
    );
  }
  return (
    <Redirect
      to={{
        pathname: `/${LINK_GROUP.CANDIDATE}/login`,
        state: { referrer: '/' },
      }}
    />
  );
};

export default LandingPage;
